module.exports = __webpack_public_path__ + "media/images/icons/logo_missing-06df827731dc678574a7ea40505ca631.png";